exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card + .card[data-v-6773c52b] {\n  margin-top: 2rem;\n}\n.post-details[data-v-6773c52b] {\n  margin: 2rem 0;\n}", ""]);

// exports
